import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import { fetchProducts } from '../lib/api';

const ProductShowcase = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    fetchProducts({ isPublished: 'true', limit: 6 }).then((data) => {
      if (isMounted) {
        setProducts(data);
        setLoading(false);
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <section className="py-10 lg:py-12 bg-[#FFFFFF]">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
          <div className="text-left mb-8">
            <h2 className="font-serif text-[24px] text-[#1a1a1a]">Tried and True</h2>
          </div>
          <div className="text-[#7a6a54] text-sm">Loading featured collection...</div>
        </div>
      </section>
    );
  }

  if (!products.length) return null;

  return (
    <section className="py-10 lg:py-12 bg-[#FFFFFF]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="text-left mb-8">
          <h2 className="font-serif text-[24px] text-[#1a1a1a]">Tried and True</h2>
        </div>

        <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-3 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none no-scrollbar gap-4 lg:gap-6 -mx-6 px-6 sm:mx-0 sm:px-0">
          {products.map(p => (
            <div key={p.id} className="flex-shrink-0 snap-center w-full sm:w-auto">
              <ProductCard product={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
